import { Lang_Types } from '../constants';

interface IMonths {
    shorthand: [
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string
    ];
    longhand: [
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string,
        string
    ];
}

/**
 * Me devuelve los meses en formato corto y largo dependiendo del idioma que estemos trabajando en el momento
 * @param lang string
 * @returns IMonths
 */
export const getMonths = (lang: string) => {
    let months: IMonths = {
        shorthand: ['', '', '', '', '', '', '', '', '', '', '', ''],
        longhand: ['', '', '', '', '', '', '', '', '', '', '', ''],
    };

    const spanish: IMonths = {
        shorthand: [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Sep',
            'Оct',
            'Nov',
            'Dic',
        ],
        longhand: [
            'Enero',
            'Febrero',
            'Мarzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],
    };

    const english: IMonths = {
        shorthand: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'June',
            'July',
            'Aug',
            'Sept',
            'Oct',
            'Nov',
            'Dec',
        ],
        longhand: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
    };

    switch (lang) {
        case Lang_Types['ES-CO']:
            months.shorthand = spanish.shorthand;
            months.longhand = spanish.longhand;
            break;

        case Lang_Types['EN-US']:
            months.longhand = english.longhand;
            months.shorthand = english.shorthand;
            break;

        default:
            months.shorthand = spanish.shorthand;
            months.longhand = spanish.longhand;
            break;
    }

    return { ...months };
};
